import _ from 'lodash'
import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import styled from 'styled-components'
import qs from 'qs'
import { connect } from 'react-redux'
import { updateCalculator } from '../../../actions/calculator'
import { fetchSports } from '../../../actions/sports'
import { fetchSportVariant } from '../../../actions/variants'
import Banner from '../../Calculator/Banner'
import PackageCard from '../../Calculator/Card/PackageCard'
import Button from '../../UI/Button'
import Tab from '../../Calculator/Tabs/Tab'
import { Wrapper, Content, Caret } from './Step0'
import { ButtonWrapper } from './Step3'
import { priceFormatted, getNetPrice, getTax } from '../../../utils/helpers'

export const Tabs = styled.div`
  display: flex;
  justify-content: ${props => props.tabCount < 3 ? 'center' : 'space-between'};
  margin-bottom: 15px;
`

class Step2 extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedPackage: {}
    }
  }

  componentDidMount () {
    const { sports, selectedPackage } = this.props
    const { sport } = this.props.match.params
    const variant = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).variant
    // If sports is empty (Usually if this step is reached directly)

    if (sports.length === 0) {
      this.props.fetchSports((sports) => {
        // Get the response directly from the callback and use it
        // Find the sport using the token
        const currentSport = _.find(sports, { token: sport })
        const data = {
          name: currentSport.name,
          active: true,
          visited: true
        }
        // Update the calculator with step number and data to update
        this.props.updateCalculator(1, data)
      })
    }
    // Fetch the variant
    this.props.fetchSportVariant(variant, (data) => {
      // Update the calculator step 1 with selected component
      this.props.updateCalculator(1, {
        selectedComponent: data.name
      })
      if (selectedPackage) {
        this.setState({ selectedPackage })
      }
      if (sports.length !== 0) {
        // Find the sport using the token
        const currentSport = _.find(sports, { token: sport })
        const data = {
          name: currentSport.name,
          active: false,
          visited: true,
          path: `/noleggia/${sport}/1`,
          sportId: currentSport.id
        }
        // Update the calculator with step number and data to update
        this.props.updateCalculator(1, data)
      }
      // Set the current step to active and visited
      this.props.updateCalculator(2, {
        active: true,
        visited: true,
        path: `/noleggia/${sport}/2?variant=${data.id}`
      })
    })

    // Set the current step to active and visited
    this.props.updateCalculator(2, {
      active: true,
      visited: true
    })
  }

  componentDidUpdate (prevProps) {
    const previousVariant = qs.parse(prevProps.location.search, { ignoreQueryPrefix: true }).variant
    const currentVariant = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).variant
    if (currentVariant !== previousVariant) {
      const { sports, selectedPackage } = this.props
      const { sport } = this.props.match.params
      if (selectedPackage) {
        this.setState({ selectedPackage })
      }
      // Fetch the variant
      this.props.fetchSportVariant(currentVariant, (data) => {
        // Update the calculator step 1 with selected component
        this.props.updateCalculator(1, {
          selectedComponent: data.name
        })

        if (sports.length !== 0) {
          // Find the sport using the token
          const currentSport = _.find(sports, { token: sport })
          const data = {
            name: currentSport.name,
            active: false,
            visited: true,
            path: `/noleggia/${sport}/1`,
            sportId: currentSport.id
          }
          // Update the calculator with step number and data to update
          this.props.updateCalculator(1, data)
        }
        // Set the current step to active and visited
        this.props.updateCalculator(2, {
          active: true,
          visited: true
        })
      })
    }
  }

  handleNext () {
    const { selectedPackage } = this.state
    const { sport } = this.props.match.params
    const variant = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).variant
    const path = `/noleggia/${sport}/3?variant=${variant}`
    if (!_.isEmpty(selectedPackage)) {
      const price = _.find(selectedPackage.items, { code: 1 }).amount
      const data = {
        price: price,
        net: getNetPrice(price),
        tax: getTax(price),
        selectedComponent: selectedPackage.name,
        packageDetails: selectedPackage
      }
      // Update the calculator for step 2
      this.props.updateCalculator(2, data)
      this.props.updateCalculator(3, { path })
      this.props.history.push(path)
    }
  }

  handleCardSelection (packageItem) {
    const selectedPackage = packageItem
    const { sport } = this.props.match.params
    const variant = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).variant
    const path = `/noleggia/${sport}/3?variant=${variant}`
    if (!_.isEmpty(selectedPackage)) {
      const price = _.find(selectedPackage.items, { code: 1 }).amount
      const data = {
        price: price,
        net: getNetPrice(price),
        tax: getTax(price),
        selectedComponent: selectedPackage.name,
        packageDetails: selectedPackage
      }
      // Update the calculator for step 2
      this.props.updateCalculator(2, data)
      this.props.updateCalculator(3, { path })
      this.props.history.push(path)
    }
    // this.setState({ selectedPackage: packageItem })
  }

  renderHeadTags () {
    const { sport } = this.props.match.params
    const variant = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).variant
    if (sport === 'calcetto') {
      if (variant === '1') {
        return (
          <Helmet>
            <title>Noleggio gabbia street soccer</title>
            <meta name='Description' content='Gabbia 2v2 e Gabbia 3v3. Configura in pochi e semplici passaggi la tua soluzione di noleggio! Preventivo GRATIS ed in tempo reale!' />
            <meta name='Keywords' content='soccer arena,calcio 2 contro 2,street soccer cage' />
          </Helmet>
        )
      } else if (variant === '2') {
        return (
          <Helmet>
            <title>Noleggio campo calcio a 5</title>
            <meta name='Description' content='Crea il tuo campo calcio a 5 IN SOLI 5 MINUTI! Puoi personalizzare il tuo noleggio con TRANSENNE DI CONTENIMENTO, IMPIANTO AUDIO e IMPIANTO LUCI!' />
            <meta name='Keywords' content='calcio a 5,campo calcetto costo,campo sintetico costo metro quadro' />
          </Helmet>
        )
      } else if (variant === '3') {
        return (
          <Helmet>
            <title>Noleggio campo calcio a 7</title>
            <meta name='Description' content='Description" content="Crea il tuo campo da calcio a 7 con Noleggiocampi.it! Aggiungi IMPIANTO AUDIO, IMPIANTO LUCI e GAZEBI. Il prezzo del noleggio è in tempo reale!' />
            <meta name='Keywords' content='calcio a 7,porte calcetto,campi da calcetto temporanei' />
          </Helmet>
        )
      }
    } else if (sport === 'basket') {
      if (variant === '4') {
        return (
          <Helmet>
            <title>Noleggio Campo street basket 3x3</title>
            <meta name='Description' content='Con il nostro servizio di CONFIGURAZIONE puoi creare il tuo campo da basket street 3x3. Personalizza il canestro da basket e rendi TOP il tuo evento!' />
            <meta name='Keywords' content='street basket,basket 3x3,pavimentazione campo basket esterno' />
          </Helmet>
        )
      } else if (variant === '5') {
        return (
          <Helmet>
            <title>Noleggio Campo basket 5x5</title>
            <meta name='Description' content='Configura il tuo noleggio per campo da basket 5vs5 con il nostro servizio GRATUITO! In soli 5 minuti avrai tutti i dati necessari per organizzare il tuo evento!' />
            <meta name='Keywords' content='canestro da basket,canestro basket esterno,noleggio campo basket smontabile' />
          </Helmet>
        )
      }
    } else if (sport === 'beach-volley') {
      if (variant === '6') {
        return (
          <Helmet>
            <title>Noleggio Campo beach volley</title>
            <meta name='Description' content='Noleggio campo beach volley con sabbia, rete e pallone beach volley! Direttamente ON-LINE! Facile, Veloce e Gratuito!' />
            <meta name='Keywords' content='sabbia beach volley,costo sabbia per campo beach volley,quanto costa fare un campo da beach volley' />
          </Helmet>
        )
      }
    }
  }

  render () {
    const { sports, variant } = this.props
    const { sport } = this.props.match.params // Sport token from URL
    const currentSport = _.find(sports, { token: sport }) // Current sport object
    const currentVariant = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).variant
    if (!currentSport || variant.length === 0) {
      return (
        <div>Loading...</div>
      )
    }
    return (
      <Wrapper>
        {this.renderHeadTags()}
        <Tabs tabCount={currentSport.variants.length}>
          {currentSport.variants.map((variant, index) => (
            <Tab
              to={`/noleggia/${sport}/2?variant=${variant.id}`}
              active={variant.id.toString() === currentVariant.toString()}
              key={index}
            >
              {variant.name === 'Gabbia' ? 'Gabbia' : currentSport.name} <br /> {variant.name === 'Gabbia' ? '2vs2 / 3vs3' : variant.type_name}
            </Tab>
          ))}
        </Tabs>
        <Banner
          title='PACCHETTO'
          subtitle='SCEGLI IL PACCHETTO PIÙ ADATTO ALLE TUE ESIGENZE!'
        />
        <Content cardCount={variant.packages.length}>
          {variant.packages.map((packageItem, index) => (
            <PackageCard
              name={packageItem.name}
              // Package price is sum of all amounts of display_type_id === 1
              price={priceFormatted(_.reduce(packageItem.items,
                (sum, item) => item.display_type_id === 1 ? sum + item.amount : sum,
                0))}
              footerText={packageItem.package_preview}
              image={`${process.env.PUBLIC_URL}/images/${packageItem.img}`}
              key={packageItem.id}
              selected={this.state.selectedPackage.id === packageItem.id}
              onClick={this.handleCardSelection.bind(this, packageItem)}
            />
          ))}
        </Content>
        <ButtonWrapper>
          <Button to={`/noleggia/${sport}/1`} size='small'><Caret transform='rotate(180)' fill='#fff' /> &nbsp;&nbsp; STEP PRECEDENTE</Button>
          <Button onClick={this.handleNext.bind(this)} size='small'>STEP SUCCESSIVO &nbsp;&nbsp; <Caret fill='#fff' /></Button>
        </ButtonWrapper>
      </Wrapper>
    )
  }
}

function mapStateToProps (state) {
  return {
    sports: state.sports.data,
    variant: state.variants.data,
    selectedPackage: state.calculator.steps[1].packageDetails
  }
}

export default connect(mapStateToProps, { updateCalculator, fetchSports, fetchSportVariant })(Step2)



// WEBPACK FOOTER //
// ./src/components/Pages/Calculator/Step2.js